import React from 'react'
import { Button, Modal } from 'react-bootstrap'

interface ModalConfirmacionProps {
    show: boolean
    title?: string
    message: string
    confirmText?: string
    cancelText?: string
    variant?: 'danger' | 'primary'
    onConfirm: () => void
    onCancel: () => void
}

const ModalConfirmacion = ({
    show,
    title = 'Confirmar acción',
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    variant = 'danger',
    onConfirm,
    onCancel
}: ModalConfirmacionProps) => {
    return (
        <Modal show={show} onHide={onCancel} centered style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}>
            <Modal.Header closeButton={false} className="modal-header-danger" >
                <Modal.Title style={{ color: 'white', fontWeight: 'bold' }}>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="mb-0">{message}</p>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {cancelText}
                </Button>
                <Button variant={variant} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfirmacion
